import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaRegHeart,
  FaRegUser,
} from "react-icons/fa";
import { BsCart } from "react-icons/bs";
import "../assets/styles/Header.css";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { BaseUrl } from "../config/api";

const Header = () => {
  const { toggleCart, cartItems } = useCart();
  const { wishlistItems } = useWishlist();
  const [announcementIndex, setAnnouncementIndex] = useState(0);
  const [announcements, setAnnouncements] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await fetch(`${BaseUrl}/marketing/getallcontents`);
        if (!response.ok) {
          console.error("Failed to fetch announcements:", response.status);
          return;
        }
        const data = await response.json();
        if (Array.isArray(data)) {
          setAnnouncements(data.map((item) => item.content));
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (announcements.length > 1) {
      const timer = setInterval(() => {
        setAnnouncementIndex((prev) => (prev + 1) % announcements.length);
      }, 3000);

      return () => clearInterval(timer);
    }
  }, [announcements]);

  return (
    <>
      {announcements.length > 0 && (
        <div className="announcement-bar">
          <div className="announcement-text">
            Free Shipment On Orders Over $ 150 AUD
          </div>
        </div>
      )}
      <header className="header">
        <div className="header-content container">
          <div className="main-header-row">
            <div className="logo-section">
              <Link to="/">
                <img src="/logo.jpg" alt="Varnamika" />
              </Link>
            </div>

            <div className="brand-section">
              <Link to="/" className="brand-name">
                Varnamika
              </Link>
            </div>

            <div className="header-actions">
              <Link to="/favourites">
                <button className="wishlist-btn">
                  <FaRegHeart />
                  {wishlistItems.length > 0 && (
                    <span className="header-wishlist-count">
                      {wishlistItems.length}
                    </span>
                  )}
                </button>
              </Link>
              <Link to="/my-account">
                <button className="account-btn">
                  <FaRegUser />
                </button>
              </Link>
              <button className="cart-btn" onClick={toggleCart}>
                <BsCart />
                {cartItems.length > 0 && (
                  <span className="header-cart-count">{cartItems.length}</span>
                )}
              </button>
            </div>

            <button
              className={`mobile-menu-btn ${isMobileMenuOpen ? "open" : ""}`}
              onClick={toggleMobileMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          <div className="nav-container">
            <nav className={`nav-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
              <NavLink to="/" onClick={handleNavLinkClick}>
                Home
              </NavLink>
              <NavLink to="/new-collections" onClick={handleNavLinkClick}>
                New Collections
              </NavLink>
              <NavLink to="/products" onClick={handleNavLinkClick}>
                Sarees
              </NavLink>
              <NavLink to="/category/blouse" onClick={handleNavLinkClick}>
                Blouse
              </NavLink>
              <NavLink to="/category/ready-to-wear" onClick={handleNavLinkClick}>
                Ready to Wear
              </NavLink>
              <NavLink to="/category/dupattas" onClick={handleNavLinkClick}>
                Dupattas
              </NavLink>
              <NavLink to="/category/half-sarees" onClick={handleNavLinkClick}>
                Half Sarees
              </NavLink>
              <NavLink to="/category/kids-wear" onClick={handleNavLinkClick}>
                Kids Wear
              </NavLink>
              <NavLink to="/category/accessories" onClick={handleNavLinkClick}>
                Accessories
              </NavLink>
            </nav>
            <div
              className={`mobile-menu-overlay ${isMobileMenuOpen ? "active" : ""
                }`}
              onClick={toggleMobileMenu}
            ></div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
